
import { reduceCall } from '../utils/util'
export default {
  install (Vue) {
    Vue.directive('bccinfinite', {
      params: ['callback'],
      bind: function (el, binding) {
        el._finish = false
        el._fire = reduceCall(function () {
          const scrollHeight = el.scrollHeight
          const offsetHeight = el.offsetHeight
          const scrollTop = el.scrollTop
          if (scrollHeight - offsetHeight - scrollTop < 1) {
            !el._finish && binding.value[1]()
          }
        }, 100)
        el.addEventListener('scroll', el._fire, false)
      },
      update: function (el, binding) {
        el._finish = binding.value[0]
      },
      unbind: function (el) {
        el.removeEventListener('scroll', el._fire)
      }
    })
  }
}
